export const artificialIntelligenceConst = {
  path: "/single-programs/artificial-intelligence",
  title: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – ИСКУССТВЕННЫЙ ИНТЕЛЛЕКТ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Искусственный интеллект — технологии, которые формируют будущее</h2>
      <p>
        Программа по искусственному интеллекту готовит специалистов, способных создавать интеллектуальные системы, обучать нейросети,
        анализировать данные и разрабатывать решения, которые меняют мир. Это одно из самых востребованных и быстроразвивающихся направлений
        в современной цифровой экономике.
      </p>
      <p>
        Студенты изучают машинное обучение, компьютерное зрение, работу с большими данными и языковыми моделями. Программа построена вокруг
        практических кейсов, современных инструментов и подготовки к реальной работе в high-tech компаниях.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Машинное обучение и нейронные сети</li>
        <li>Языки программирования (Python, R)</li>
        <li>Математика и статистика для AI</li>
        <li>Большие данные и облачные вычисления</li>
        <li>Обработка естественного языка (NLP)</li>
        <li>Компьютерное зрение</li>
        <li>Алгоритмы и структуры данных</li>
        <li>Этические и юридические аспекты AI</li>
        <li>Разработка AI-продуктов в команде</li>
        <li>Практика и проекты с индустриальными партнерами</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>AI-разработчик</li>
        <li>ML-инженер</li>
        <li>Data scientist</li>
        <li>Специалист по компьютерному зрению</li>
        <li>Аналитик данных</li>
        <li>Исследователь в области искусственного интеллекта</li>
        <li>Продуктовый менеджер AI-решений</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€60,000 до €120,000 в год,</strong> в зависимости от специализации и уровня.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в странах ЕС</li>
        <li>Современная программа, ориентированная на практику</li>
        <li>Возможность обучения на русском или английском языке</li>
        <li>Доступ к облачным лабораториям и вычислительным ресурсам</li>
        <li>Участие в международных хакатонах и AI-чемпионатах</li>
        <li>Индивидуальный подход и наставничество от экспертов отрасли</li>
      </ul>
      <p>Искусственный интеллект — это не просто технология. Это новая эра. Мы готовим тех, кто её создаёт.</p>
      <h2>Как поступить?</h2>
      <p>Поступить просто — приёмная комиссия с радостью поможет вам на каждом этапе: от выбора программы до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Искусственный интеллект — технологии, которые формируют будущее
    Программа по искусственному интеллекту готовит специалистов, способных создавать интеллектуальные системы, обучать нейросети, анализировать данные и разрабатывать решения, которые меняют мир. Это одно из самых востребованных и быстроразвивающихся направлений в современной цифровой экономике.
    Студенты изучают машинное обучение, компьютерное зрение, работу с большими данными и языковыми моделями. Программа построена вокруг практических кейсов, современных инструментов и подготовки к реальной работе в high-tech компаниях.

    Что вы будете изучать?
    • Машинное обучение и нейронные сети
    • Языки программирования (Python, R)
    • Математика и статистика для AI
    • Большие данные и облачные вычисления
    • Обработка естественного языка (NLP)
    • Компьютерное зрение
    • Алгоритмы и структуры данных
    • Этические и юридические аспекты AI
    • Разработка AI-продуктов в команде
    • Практика и проекты с индустриальными партнерами

    Кем можно работать после окончания?
    • AI-разработчик
    • ML-инженер
    • Data scientist
    • Специалист по компьютерному зрению
    • Аналитик данных
    • Исследователь в области искусственного интеллекта
    • Продуктовый менеджер AI-решений

    Средний доход в Европе:
    от €60,000 до €120,000 в год, в зависимости от специализации и уровня.

    Почему выбирают нас?
    • Европейский диплом, признанный в странах ЕС
    • Современная программа, ориентированная на практику
    • Возможность обучения на русском или английском языке
    • Доступ к облачным лабораториям и вычислительным ресурсам
    • Участие в международных хакатонах и AI-чемпионатах
    • Индивидуальный подход и наставничество от экспертов отрасли

    Искусственный интеллект — это не просто технология. Это новая эра. Мы готовим тех, кто её создаёт.

    Как поступить?
    Поступить просто — приёмная комиссия с радостью поможет вам на каждом этапе: от выбора программы до подачи заявки.
  `,
};
